import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import User from "../interfaces/User";

export interface createSidebarState {
  selectedSidebarUser: User | null;
}

const initialState: createSidebarState = {
  selectedSidebarUser: null,
};

export const createSidebarSlice = createSlice({
  name: "sidebarState",
  initialState,
  reducers: {
    setSelectedSidebarUser: (state, action: PayloadAction<User | null>) => {
      state.selectedSidebarUser = action.payload;
    },
    resetSidebarState: () => initialState,
  },
});

export const { setSelectedSidebarUser, resetSidebarState } =
  createSidebarSlice.actions;

export default createSidebarSlice.reducer;
